<template>
  <div class="ferry-info">
    <h2 class="title">
      {{ $t(title) }}
    </h2>
    <p class="info">
      <span><span class="secondary-text">{{ $t('流水号') }}: </span>{{ data.serialNumber || '-' }}</span>
      <span v-if="isOuter || isReceive"><span class="secondary-text">{{ $t('更新时间') }}:
      </span>{{ getTime(data.mtime) }}</span>
      <span>
        <span class="secondary-text">{{ $t('创建时间') }}: </span>
        {{ getTime(data.ctime) }}
      </span>
    </p>
    <div class="detail">
      <div class="detail_left">
        <div
          class="status"
          :class="[`bg-${statusClass}`]"
        >
          <svg
            class="status_icon"
            width="30px"
            height="30px"
          >
            <use
              :xlink:href="`#${svgId}`"
            />
          </svg>
          <p class="status_text">
            {{ $t(statusText) }}
          </p>
        </div>
        <div
          v-if="status==='agreed' && character==='applier'"
          class="link"
        >
          <a @click="openExchangeDetail">{{ $t('查看摆渡详情') }}</a>
        </div>

        <!-- 重试 -->
        <div
          v-if="showReset"
          class="reset"
          @click="handleReset"
        >
          {{ $t('重试') }}
        </div>
        <!-- 转存 -->
        <div
          v-if="cSave"
          class="reset"
          @click="handleReSave"
        >
          {{ $t('转存') }}
        </div>
      </div>
      <div class="detail_right table">
        <template v-if="isApprover">
          <p class="row">
            <span class="secondary-text cell label">{{ `${$t('发起者')}:` }}</span>
            <span class="cell">
              <template>
                {{ data.sender.username || '' }}{{ data.sender.email ? ` (${data.sender.email})` : '' }}
              </template>
            </span>
          </p>
          <p
            v-if="data.approveData.approved_desc || data.approveData.approved_desc === ''"
            class="row"
          >
            <span class="secondary-text cell label">{{ `${$t('审批意见')}:` }}</span>
            <span class="cell">{{ data.approveData.approved_desc || '-' }}</span>
          </p>
          <p class="row">
            <span class="secondary-text cell label">{{ `${$t('申请理由')}:` }}</span>
            <span class="cell">{{ data.approveData.apply_desc || '-' }}</span>
          </p>
        </template>
        <template v-if="isApplier">
          <p class="row">
            <span class="secondary-text cell label">{{ `${$t('审批者')}:` }}</span>
            <span
              v-if="data.approveData.approve_uids"
              class="cell"
            >
              <template
                v-for="(item, index) of data.approveData.approve_uids"
              >
                <el-tooltip
                  :key="`${item.id}-name`"
                  placement="right"
                  transition=".el-fade-in"
                  :open-delay="200"
                  :enterable="false"
                  :content="item.email"
                >
                  <span>{{ item.name }}</span>
                </el-tooltip>
                <span
                  v-if="index < data.approveData.approve_uids.length-1"
                  :key="`${item.id}-don`"
                >、</span>
              </template>
            </span>
          </p>
          <p
            v-if="data.approveData.approved_desc || data.approveData.approved_desc === ''"
            class="row"
          >
            <span class="secondary-text cell label">{{ `${$t('审批意见')}:` }}</span>
            <span class="cell">{{ data.approveData.approved_desc || '-' }}</span>
          </p>
          <p class="row">
            <span class="secondary-text cell label">{{ `${$t('申请理由')}:` }}</span>
            <span class="cell">{{ data.approveData.apply_desc || '-' }}</span>
          </p>
        </template>
        <template v-if="isOuter || isReceive">
          <div
            v-if="data.elseStatus && isError"
            class="err-message"
          >
            <svg
              class="small-icon"
              width="14px"
              height="14px"
            >
              <use
                :xlink:href="`#${samllSvg}`"
              />
            </svg>
            <span
              style="vertical-align:middle"
            >{{ showErrorReason }}
            </span>
          </div>
          <p>
            <span class="secondary-text">{{ `${$t('发起者')}：` }}
            </span>{{ data.sender.username || '' }}{{ data.sender.email ? ` (${data.sender.email})` : '' }}
          </p>
          <!-- 接收空间不显示审批者 -->
          <p v-if="data.approvePolicy && isOuter">
            <span class="secondary-text">
              {{ `${$t('审批者')}：` }}
            </span><!-- 审批者列表 -->
            <template v-if="data.approvePolicy.length === 0">
              <el-tooltip
                placement="right"
                transition=".el-fade-in"
                :open-delay="200"
                :enterable="false"
                content="-"
              >
                <span>-</span>
              </el-tooltip>
            </template>
            <template v-else>
              <template
                v-for="(item, index) of data.approvePolicy.approve_uids"
              >
                <el-tooltip
                  :key="`${item.id}-name`"
                  placement="right"
                  transition=".el-fade-in"
                  :open-delay="200"
                  :enterable="false"
                  :content="item.email"
                >
                  <span>{{ item.name }}</span>
                </el-tooltip>
                <span
                  v-if="index < data.approvePolicy.approve_uids.length-1"
                  :key="`${item.id}-don`"
                >、</span>
              </template>
            </template>
          </p>
        </template>
      </div>
    </div>
    <div class="divider" />
    <div class="footer table">
      <p class="row" v-if="data.approveData.approve_policy_name && isApprover">
        <span class="secondary-text label cell">{{ `${$t('敏感信息管控')}:` }}</span>
        <span class="cell">
          {{ $t('包含敏感信息，命中{n}策略',{n: data.approveData.approve_policy_name }) }}
        </span>
      </p>
      <p class="row">
        <span class="secondary-text label cell">{{ `${$t('摆渡通道')}:` }}</span>
        <span class="cell">
          {{ data.channelName || '-' }}
        </span>
      </p>
      <p class="row">
        <span class="secondary-text label cell">{{ `${$t('摆渡模式')}:` }}</span>
        <span class="cell">
          {{ exchangeMode(data) }}
        </span>
      </p>
      <p class="row" v-if="data.sendNamespace === 1">
        <span class="secondary-text label cell">{{ `${$t('摆渡接收者')}:` }}</span>
        <span class="cell">
          {{ data.receiverSlug }}
        </span>
      </p>
      <div class="send-path row">
        <div class="secondary-text label cell">
          {{ `${$t('来源路径')}:` }}
        </div>
        <el-tooltip
          :content="sendNameSpace"
          placement="bottom"
          transition=".el-fade-in"
          :open-delay="200"
          :enterable="false"
        >
          <v-clamp
            class="content cell"
            autoresize
            :max-lines="2"
          >
            {{ sendNameSpace || '' }}
          </v-clamp>
        </el-tooltip>
      </div>
      <div
        v-if="isReceive"
        class="receive-path row"
      >
        <div class="secondary-text label cell">
          {{ `${$t('接收路径')}:` }}
        </div>
        <el-tooltip
          :content="receivePath"
          placement="bottom"
          transition=".el-fade-in"
          :open-delay="200"
          :enterable="false"
        >
          <v-clamp
            class="content cell"
            autoresize
            :max-lines="2"
          >
            {{ receivePath || '' }}
          </v-clamp>
        </el-tooltip>
      </div>
    </div>
    <transferDialog
      :value="isShow"
      :title="`${$t('转存至网盘')}`"
      height="400"
      width="520"
      @close="isShow = false"
    >
      <template slot="content">
        <transfer
          :child-content="value"
          :target-path="data.targetPath"
          :save-status="saveStatus"
          @close="isShow = false"
        />
      </template>
      <template slot="button">
        <div />
      </template>
    </transferDialog>
  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import transfer from 'components/common/transfer/index.vue'
import transferDialog from 'components/common/dialog'
import _$ from 'js/api/getdata.js'
import { formatDate } from 'js/util/util.js'

export default {
  components: {
    VClamp,
    transfer,
    transferDialog,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    value: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      showHeader: false,
      errReason: '',
      isShow: false,
      samllSvg: '', // 小图标
      character: '',
      status: '',
      statusClass: '',
      svgId: '',
      statusText: '',
      approverList: [],
      ferryStatus: 0,
      saveStatus: 0, // 能够转存去哪  0-> 企业空间 1-> 个人空间 + 企业空间 2->不能转存
    }
  },
  computed: {
    showErrorReason() {
      const status = this.data.elseStatus
      if (this.isOuter) {
        switch (status) {
          case 1:
            return this.$t('包含敏感信息禁止摆渡')
            break
          case 2:
            return this.$t('包含病毒禁止摆渡')
            break
          case 3:
            return this.$t('审批拒绝')
            break
          case 4:
            return this.$t('服务器连接失败')
            break
          case 5:
            return this.$t('敏感信息扫描失败')
            break
          case 6:
            return this.$t('病毒扫描失败')
            break
          case 7:
            return this.$t('审批失效')
            break
          case 8:
            return this.$t('审批过期')
            break
          case 9:
            return this.$t('通道不存在')
            break
          case 10:
            return this.$t('对摆渡文件无下载权限')
            break
          case 11:
            return this.$t('文件类型不允许摆渡')
            break
          case 12:
            return this.$t('文件过大')
            break
          case 13:
            return this.$t('文件数量超过上限')
            break
          case 14:
            return this.$t('其他')
            break
          default:
            return ''
        }
      }
      if (this.isReceive) {
        switch (status) {
          case 1:
            return this.$t('接收规则不存在')
            break
          case 2:
            return this.$t('未匹配到接收用户')
            break
          case 3:
            return this.$t('接收用户状态异常')
            break
          case 4:
            return this.$t('接收路径不存在')
            break
          case 5:
            return this.$t('接收者在接收路径无权限')
            break
          case 6:
            return this.$t('接收路径空间不足')
            break
          case 7:
            return this.$t('接收路径上有上传审批')
            break
          case 8:
            return this.$t('存在锁定同名冲突文件')
            break
          case 9:
            return this.$t('存在不允许上传的格式')
          case 10:
            return this.$t('其他')
          default:
            return ''
        }
      }
      return ''
    },
    // 错误子原因展示

    showReset() {
      if (this.data.status === 4 && this.isOuter) {
        return true
      }
      return false
    },
    // 重试按钮显示

    isError() {
      if (this.isOuter) {
        if (this.data.status === 4 || this.data.status === 5) {
          return true
        }
      } else if (this.data.status === 0 || this.data.status === 1) {
        return true
      }
      return false
    },
    // 是否显示错误原因

    cSave() {
      if (this.isReceive) {
        if (this.data.status === 0 || this.data.status === 1) {
          if (this.saveStatus !== 2) {
            return true
          }
          return false
        }
      }
      return false
    },
    // 判断是否可以缓存

    isOuter() {
      return this.character === 'outer'
    },
    // 外发
    isReceive() {
      return this.character === 'receive'
    },
    // 接收

    isApplier() {
      return this.character === 'applier'
    },

    isApprover() {
      return this.character === 'approver'
    },

    title() {
      if (this.isApplier || this.isApprover) {
        return this.$t('摆渡审批详情')
      } if (this.isOuter) {
        return this.$t('摆渡外发详情')
      } if (this.isReceive) {
        return this.$t('摆渡接收详情')
      }
      return ''
    },
    fileFrom() {
      return this.data.sendNamespace === 0 ? this.$t('企业空间') : this.$t('个人空间')
    },
    sendNameSpace() {
      const space = this.fileFrom
      if (!this.data.sendPath) { return '-' }
      return this.data.sendPath !== '/' ? space + this.data.sendPath : space
    },
    receivePath() {
      let space = ''
      if (this.data.receivePath === '' || this.data.receivePath === null) {
        space = '-'
      } else if (this.data.receivePath !== '/') {
        space = this.fileFrom + this.data.receivePath
      } else {
        space = this.fileFrom
      }
      return space
    },
  },
  watch: {
    data(newVal) {
      this.ferryStatus = newVal.status
    },
  },
  created() {
    this.character = sessionStorage.getItem('character')
    if (this.$route.name === 'ferry') {
      this.setFerryStatus(this.data.status)
      if (this.isReceive) {
        this.saveToWhere()
      }
    } else {
      this.setApproveStatus(this.data.approveData.status)
    }
  },
  methods: {
    getTime(time) {
      if (!time) { return '-' }
      return formatDate(new Date(time), 'yyyy-MM-dd hh:mm')
    },
    saveToWhere() {
      const { data } = this
      // 管理控制台
      if (data.fromType === '1') {
        if (data.sendNamespace === 0) {
          this.saveStatus = 0
        } else {
          this.saveStatus = 1
        }
      }
      if (data.fromType === '0') {
        if (data.status === 0) {
          if (data.sendNamespace === 0) {
            this.saveStatus = 0
          } else {
            this.saveStatus = 1
          }
        }
        if (data.status === 1) {
          if (data.sendNamespace === 0) {
            this.saveStatus = 2
          } else {
            this.saveStatus = 1
          }
        }
      }
    },
    // 判断能转存的位置

    setTime(val) {
      return val < 10 ? `0${val}` : val
    },

    // 处理重试按钮
    handleReset() {
      // 点击状态变为等待发送  调接口
      const params = {
        url: `/${this.data.serialNumber}`,
      }
      _$.postData('resetFerryTask', '', params).then((res) => {
        if (res.data.code === 200) {
          // 刷新页面
          window.$toast.simpleShow(this.$t('重试成功'), 'warn')
          setTimeout(() => {
            location.reload()
          }, 1000)
        }
      }).catch((error) => {
        const { message } = error.response.data
        window.$toast.simpleShow(message, 'error')
      }) // 重试失败的处理
    },
    // 处理转存按钮
    handleReSave() {
      // 出一个弹框
      this.isShow = true
    },
    setFerryStatus(ferryStatus) {
      if (this.isOuter) {
        switch (ferryStatus) {
          case 0:
            // 安全扫描
            this.svgId = 'safe-scan'
            this.statusClass = 'uncommitted'
            this.statusText = this.$t('安全扫描中')
            break
          case 1:
            // 待审批
            this.svgId = 'pending'
            this.statusText = this.$t('待审批')
            this.statusClass = 'warning'
            break
          case 2:
            // 待发送
            this.svgId = 'uncommitted'
            this.statusText = this.$t('等待发送')
            this.statusClass = 'warning'
            break
          case 3:
            // 发送成功
            this.svgId = 'success-white'
            this.statusText = this.$t('发送成功')
            this.statusClass = 'success'
            break
          case 4:
            // 发送失败
            this.svgId = 'error-white'
            this.statusText = this.$t('发送失败')
            this.statusClass = 'danger'
            this.samllSvg = 'error-small'
            break
          case 5:
            // 禁止发送
            this.svgId = 'remove'
            this.statusText = this.$t('禁止发送')
            this.statusClass = 'danger'
            this.samllSvg = 'error-small'
            break
          case 6:
            // 发送中
            this.svgId = 'uncommitted'
            this.statusText = this.$t('发送中')
            this.statusClass = 'warning'
            break
          default:
        }
      } else if (!this.isOuter) {
        switch (ferryStatus) {
          case 0:
            // 待提取
            this.svgId = 'pending'
            this.statusText = this.$t('等待提取')
            this.statusClass = 'warning'
            this.samllSvg = 'pending-small'
            break
          case 1:
            // 转存失败
            this.svgId = 'error-white'
            this.statusText = this.$t('转存失败')
            this.statusClass = 'danger'
            this.samllSvg = 'error-small'
            break
          case 2:
            // 转存成功
            this.svgId = 'success-white'
            this.statusText = this.$t('转存成功')
            this.statusClass = 'success'
            break
          case 3:
            // 转存中
            this.svgId = 'uncommitted'
            this.statusText = this.$t('转存中')
            this.statusClass = 'warning'
            break
          case 4:
            // 任务异常
            this.svgId = 'task-error'
            this.statusText = this.$t('任务异常')
            this.statusClass = 'error'
            break
          default:
        }
      }
    },
    setApproveStatus(payload) {
      switch (+payload) {
        case 1:
          this.status = 'wait'
          this.statusClass = 'warning'
          this.svgId = 'pending'
          this.statusText = this.$t('待审批')
          break
        case 2:
          this.status = 'agreed'
          this.statusClass = 'success'
          this.svgId = 'success-white'
          this.statusText = this.$t('已同意')
          break
        case 3:
          this.status = 'failed'
          this.statusClass = 'danger'
          this.svgId = 'error-white'
          this.statusText = this.$t('未通过')
          break
        case 4:
          this.status = 'expired'
          this.statusClass = 'info'
          this.svgId = 'expired'
          this.statusText = this.$t('已过期')
          break
        case -1:
          this.status = 'invalid'
          this.statusClass = 'invalid'
          this.svgId = 'remove'
          this.statusText = this.$t('已失效')
          break
        case 0:
          this.status = 'uncommitted'
          this.statusClass = 'uncommitted'
          this.svgId = 'uncommitted'
          this.statusText = this.$t('未提交')
          break
        default:
      }
    },
    test() {
      const status = ['wait', 'agreed', 'failed', 'expired', 'invalid', 'uncommitted']
      const len = status.length
      const nextIndex = status.indexOf(this.status) + 2
      if (nextIndex >= len + 1) {
        this.setApproveStatus(1)
      } else {
        this.setApproveStatus(nextIndex)
      }
    },
    openExchangeDetail() {
      const detailUrl = `${window.location.protocol}//${window.location.host}/front/ferry-details?fromNeid=${this.data.id}&type=0&fromType=0&serialNumber=${this.data.serialNumber}&account_id=${this.$store.getters.accountId}&uid=${this.$store.getters.uId}`
      window.open(detailUrl)
    },
    exchangeMode(data) {
      const space = data.sendNamespace === 0 ? '企业空间' : '个人文件'
      const mode = data.mode === 0 ? '定时摆渡' : '摆渡'
      return this.$t(space + mode)
    },
  },

}
</script>

<style lang="less" scoped>
@regularText: #1B2733;
@secondaryText: #637282;
@info: #C1C7CD;
@invalid: #929CA9;
@blue: #4696FB;
@warning: #FDC82F;
@success: #00D09B;
@danger: #FD4147;
@error: #FF8700;
.small-icon:before {
  content: '';
}
.err-message {
  margin-bottom: 12px;
}
.small-icon {
  margin-right:5px;
  vertical-align:middle;
}
.secondary-text {
  color: @secondaryText;
}
.bg-error {
  background: @error;
}
.bg-warning {
  background: @warning;
}
.bg-success {
  background: @success;
}
.bg-danger {
  background: @danger;
}
.bg-info {
  background: @info;
}
.bg-invalid {
  background: @invalid;
}
.bg-uncommitted {
  background: @blue;
}

.ferry-info {
  color: @regularText;
  p:not(:last-child) {
    margin-bottom: 12px;
  }
  .title {
    font-size: 18px;
    margin-bottom: 12px;
  }
  p.info {
    margin-bottom: 24px;
  }
  .info > span:not(:last-child) {
    margin-right: 50px;
  }
  .detail {
    display: flex;
    .detail_left {
      flex: 0 0 90px;
      margin-right: 24px;
      .reset {
        cursor: pointer;
        color: #0A64FA;
        text-align: center;
        margin-top: 12px;
      }
    }
    .detail_right {
      flex: 0 1 auto;
    }
  }
  .status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90px;
    padding: 10px 0;
    border-radius: 2px;
    .status_icon {
      flex: 0 0 30px;
      margin-bottom: 10px;
    }
    .status_text {
      flex: 0 1 auto;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 16px;
      text-align: center;
    }
  }
  .link {
    text-align: center;
    a, a:hover{
      color: #0A64FA;
      cursor: pointer;
    }
  }

  .divider {
    height: 1px;
    margin: 24px 0;
    background-color: #E8EBEF;
  }

  .timing-ferry {
    margin-left: 24px;
  }

  .table {
    display: table;
  }
  .row {
    display: table-row;
  }
  .cell {
    display: table-cell;
    &.label {
      white-space: nowrap;
      padding-right: 8px;
    }
  }
  .row:not(:first-child) .cell{
    padding-top: 12px;
  }
}
</style>
